// extracted by mini-css-extract-plugin
export var cardIcon = "_av-4";
export var checkboxCard = "_av-0";
export var checkboxCardSelected = "_av-3";
export var disabled = "_av-1";
export var outerBorder = "_av-2";
export var spacerMedium = "_av-7";
export var spacerSmall = "_av-6";
export var spacerXsmall = "_av-5";